import React from 'react';
import mfgFetch from './mfg-fetch';

class ManufacturerLogout extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentWillMount() {
        window.sessionStorage.removeItem('mfg_token');
        window.location = `https://${window.location.hostname}/mfg/login`;
    }


    componentDidMount() {
    }

    render () {
        return null;
    }
}

export default ManufacturerLogout;